import { render, staticRenderFns } from "./QueueRecurrentCard.vue?vue&type=template&id=65cde716&"
import script from "./QueueRecurrentCard.vue?vue&type=script&lang=js&"
export * from "./QueueRecurrentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports